import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';

const Tab1 = ({ ItemGroupName, ParentItemGroup, UnicommerceProductCategoryCode, IsGroup }) => {

  return (
  <div>
      <div
      className="row mb-3"
      style={{ border: "1px solid #00000059", borderRadius: "5px" }}
    >
      <div className="col-12">
        <p className="boxLabel m-0">Details</p>
      </div>
      <div className="col-4 ">
        <div className="mb-3">
          <Input
            id="ItemGroupName"
            label="Item Group Name"
            style={{ height: "30px", border: ItemGroupName.Error ? "1px solid red" : "", }}
            value={ItemGroupName.ItemGroupName} readOnly
            onChange={(e) => ItemGroupName.setItemGroupName(e.target.value)}
          />
        </div>
      </div>

      <div className="col-4 ">
        <div className="mb-3">
          <Input label="Parent Item Group" readOnly value={ParentItemGroup.select_ParentItemGroup} style={{ height: '30px' }} />


        </div>
      </div>

      <div className="col-4 ">
        <div className="mb-3">
          <Input
            id="UnicommerceProductCategoryCode"
            style={{
              height: "30px",
              border: UnicommerceProductCategoryCode.Error ? "1px solid red" : "",
            }}
            label="Unicommerce Product Category Code" readOnly
            value={UnicommerceProductCategoryCode.UnicommerceProductCategoryCode}
            onChange={(e) => UnicommerceProductCategoryCode.setUnicommerceProductCategoryCode(e.target.value)}
          />
        </div>
      </div>

      <div className="col-4 ">
        <div className="mb-3">

          <Checkbox
            id="IsGroup"
            label="Is Group"
            value={IsGroup?.IsGroup || false}
            onChange={(val) => IsGroup?.setIsGroup?.(val)}
            disabled={true}
          />

          <div style={{ fontSize: "9px", color: "#00000099", marginLeft: '23px' }}>
            Only leaf nodes are allowed in transaction
          </div>
        </div>
      </div>


    </div>
     
  </div>
  )
}

export default Tab1